export const UPDATE_CREDITS = 'UPDATE_CREDITS';
